export default [

     {
          path: '/general-task',
          name: 'GeneralTask',
          component: () => import("@/views/Page/GeneralTask/GeneralTask.vue"),
          meta: {
               title: 'Task',
          },
     }
];